var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["cdu-events-component"] }, [
    _vm.screenConfiguration.is2showsingleevent
      ? _c(
          "div",
          { staticClass: "single-event" },
          _vm._l(_vm.cduSingleEvents, function(event) {
            return _c(
              "div",
              {
                class: [
                  "event",
                  event.idfosporttype.replace(/ /g, ""),
                  event.sportname.replace(/ /g, ""),
                  {
                    prematch:
                      !event.isliveevent && event.idfobolifestate === "O"
                  },
                  { resulted: event.idfobolifestate !== "O" },
                  { live: event.isliveevent && event.idfobolifestate === "O" }
                ]
              },
              [
                _c(
                  "div",
                  { staticClass: "event-info-head" },
                  [_c("cdu-info-head", { attrs: { event: event } })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "markets-columns two-columns" },
                  _vm._l(_vm.cduSingleEventsNumberOfColumns, function(column) {
                    return _c(
                      "div",
                      { staticClass: "column" },
                      [
                        (column === 0 &&
                          ((["SOCCER", "TENNIS", "BOXING", "MMA"].indexOf(
                            event.idfosporttype
                          ) === -1 &&
                            _vm.hasBig3Markets(event)) ||
                            (["SOCCER", "TENNIS", "BOXING", "MMA"].indexOf(
                              event.idfosporttype
                            ) > -1 &&
                              _vm.hasMoneylineMarkets(event)))) ||
                        _vm.brand_ultrawide
                          ? _c(
                              "div",
                              { staticClass: "event" },
                              [
                                event.isliveevent &&
                                event.idfobolifestate === "O"
                                  ? _c("live-event", {
                                      attrs: { event: event, showheader: true }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                !event.isliveevent ||
                                event.idfobolifestate !== "O"
                                  ? _c("simple-event", {
                                      attrs: { event: event, showheader: true }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !(
                          _vm.cduState === "2column-single-stats" &&
                          _vm.appConfigForBrand.showParticipantStats &&
                          _vm.screenConfiguration.is2showstats
                        )
                          ? _c(
                              "div",
                              { staticClass: "single-event-markets" },
                              [
                                _vm
                                  .cduSingleEventMarketsByPage(event)
                                  .filter(function(mk) {
                                    return _vm.singleEventOthersMarketsFilter(
                                      mk,
                                      column
                                    )
                                  }).length > 0
                                  ? _c("markets", {
                                      staticClass: "markets-container",
                                      attrs: {
                                        event: event,
                                        markets: _vm
                                          .cduSingleEventMarketsByPage(event)
                                          .filter(function(mk) {
                                            return _vm.singleEventOthersMarketsFilter(
                                              mk,
                                              column
                                            )
                                          }),
                                        is2displayhorizontally: false,
                                        forcenonbig3: true
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        (_vm.cduState === "2column-single-stats" ||
                          (column === 1 && _vm.cduState === "single-stats")) &&
                        _vm.appConfigForBrand.showParticipantStats &&
                        _vm.screenConfiguration.is2showstats
                          ? _c("event-stats", { attrs: { event: event } })
                          : _vm._e()
                      ],
                      1
                    )
                  }),
                  0
                )
              ]
            )
          }),
          0
        )
      : _vm.screenConfiguration.is2showoutrightevents
      ? _c(
          "div",
          { staticClass: "no-columns" },
          [
            _vm.screenConfiguration.is2showoutrightevents
              ? [
                  _c(
                    "div",
                    { staticClass: "events non-pinned clearfix" },
                    _vm._l(_vm.cduOutrightEvents, function(event) {
                      return event
                        ? _c(
                            "div",
                            {
                              key: event.idfoevent,
                              class: [
                                "event",
                                "outright",
                                event && event.idfosporttype,
                                { "with-header": true },
                                {
                                  prematch:
                                    !event.isliveevent &&
                                    event.idfobolifestate === "O"
                                },
                                {
                                  live:
                                    event.isliveevent &&
                                    event.idfobolifestate === "O"
                                }
                              ]
                            },
                            [
                              _c("outright-event", {
                                attrs: { event: event, showheader: true }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    }),
                    0
                  )
                ]
              : _vm._e()
          ],
          2
        )
      : _vm.screenConfiguration.is2showeventsin2columns
      ? _c(
          "div",
          {
            class: [
              "two-columns",
              {
                "all-events-same-sporttype": _vm.eventsPerColumn[1].length === 7
              }
            ]
          },
          _vm._l([1, 2], function(column) {
            return _c(
              "div",
              { staticClass: "column" },
              [
                _vm.isDebug
                  ? _c("div", { staticClass: "debug" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.eventsPerColumn[column].map(function(ev) {
                              return ev.eventrows
                            })
                          ) +
                          " " +
                          _vm._s(
                            _vm.eventsPerColumn[column]
                              .map(function(ev) {
                                return ev.eventrows
                              })
                              .reduce(function(a, b) {
                                return a + b
                              }, 0)
                          ) +
                          "\n      "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.group2ColumnEventsBy ||
                _vm.group2ColumnEventsBy === "DEFAULT"
                  ? _vm._l(_vm.eventsPerColumn[column], function(event, index) {
                      return _c(
                        "div",
                        {
                          class: [
                            "event",
                            event.idfosporttype.replace(/ /g, ""),
                            event.sportname.replace(/ /g, ""),
                            {
                              "with-header":
                                event.showeventheader || index === 0
                            },
                            {
                              "no-header": !event.showeventheader && index !== 0
                            },
                            { odd: _vm.isOdds[column][event.idfoevent] },
                            { resulted: event.idfobolifestate !== "O" },
                            {
                              prematch:
                                !event.isliveevent &&
                                event.idfobolifestate === "O"
                            },
                            {
                              live:
                                event.isliveevent &&
                                event.idfobolifestate === "O"
                            },
                            {
                              "no-markets":
                                !event.markets || event.markets.length === 0
                            },
                            { outright: event.isoutright }
                          ]
                        },
                        [
                          event.isliveevent && event.idfobolifestate === "O"
                            ? _c("live-event", {
                                attrs: {
                                  event: event,
                                  showheader:
                                    event.showeventheader || index === 0
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !event.isliveevent || event.idfobolifestate !== "O"
                            ? _c("simple-event", {
                                attrs: {
                                  event: event,
                                  showheader:
                                    event.showeventheader || index === 0
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.group2ColumnEventsBy === "DATE"
                  ? [
                      _vm._l(_vm.eventsPerColumnGroupedByDate[column], function(
                        date
                      ) {
                        return _vm._l(date, function(event, index) {
                          return _c(
                            "div",
                            {
                              class: [
                                "event",
                                event.idfosporttype.replace(/ /g, ""),
                                event.sportname.replace(/ /g, ""),
                                { "with-header": index === 0 },
                                { "no-header": index !== 0 },
                                { resulted: event.idfobolifestate !== "O" },
                                {
                                  prematch:
                                    !event.isliveevent &&
                                    event.idfobolifestate === "O"
                                },
                                {
                                  live:
                                    event.isliveevent &&
                                    event.idfobolifestate === "O"
                                },
                                {
                                  "no-markets":
                                    !event.markets || event.markets.length === 0
                                },
                                {
                                  "stats-highlight":
                                    event.idfoevent ===
                                      _vm.cduNonPinnedEventsPaged[
                                        _vm.currentStatsIndex
                                      ].idfoevent &&
                                    _vm.appConfigForBrand
                                      .showParticipantStats &&
                                    _vm.screenConfiguration.is2showstats
                                },
                                { outright: event.isoutright }
                              ]
                            },
                            [
                              event.isliveevent && event.idfobolifestate === "O"
                                ? _c("live-event", {
                                    attrs: {
                                      event: event,
                                      showheader: index === 0,
                                      headertype: _vm.group2ColumnEventsBy
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !event.isliveevent ||
                              event.idfobolifestate !== "O"
                                ? _c("simple-event", {
                                    attrs: {
                                      event: event,
                                      showheader: index === 0,
                                      headertype: _vm.group2ColumnEventsBy
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        })
                      })
                    ]
                  : _vm._e(),
                _vm._v(" "),
                column === 2 &&
                _vm.appConfigForBrand.showParticipantStats &&
                _vm.screenConfiguration.is2showstats
                  ? _c("event-stats", {
                      attrs: {
                        event:
                          _vm.cduNonPinnedEventsPaged[_vm.currentStatsIndex]
                      }
                    })
                  : _vm._e()
              ],
              2
            )
          }),
          0
        )
      : _c(
          "div",
          { staticClass: "no-columns" },
          [
            [
              _c(
                "div",
                { staticClass: "events pinned" },
                _vm._l(_vm.cduPinnedEvents, function(event) {
                  return _c(
                    "div",
                    {
                      class: [
                        "event",
                        event.idfosporttype.replace(/ /g, ""),
                        event.sportname.replace(/ /g, ""),
                        { "with-header": true },
                        { resulted: event.idfobolifestate !== "O" },
                        {
                          prematch:
                            !event.isliveevent && event.idfobolifestate === "O"
                        },
                        { outright: event.isoutright },
                        {
                          live:
                            event.isliveevent && event.idfobolifestate === "O"
                        }
                      ]
                    },
                    [
                      event.isliveevent && event.idfobolifestate === "O"
                        ? _c("live-event", {
                            attrs: { event: event, showheader: true }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !event.isliveevent || event.idfobolifestate !== "O"
                        ? _c("simple-event", {
                            attrs: { event: event, showheader: true }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "events non-pinned clearfix" },
                _vm._l(_vm.cduNonPinnedEventsPaged, function(event) {
                  return _c(
                    "div",
                    {
                      class: [
                        "event",
                        event.idfosporttype.replace(/ /g, ""),
                        event.sportname.replace(/ /g, ""),
                        { "with-header": true },
                        { resulted: event.idfobolifestate !== "O" },
                        {
                          prematch:
                            !event.isliveevent && event.idfobolifestate === "O"
                        },
                        { outright: event.isoutright },
                        {
                          live:
                            event.isliveevent && event.idfobolifestate === "O"
                        }
                      ]
                    },
                    [
                      event.isliveevent && event.idfobolifestate === "O"
                        ? _c("live-event", {
                            attrs: { event: event, showheader: true }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !event.isliveevent || event.idfobolifestate !== "O"
                        ? _c("simple-event", {
                            attrs: { event: event, showheader: true }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                }),
                0
              )
            ]
          ],
          2
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eb5f951c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb5f951c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cdu/cduEvents.vue
// module id = null
// module chunks = 